<template>
  <div class="container-content">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // Ensure proper viewport settings for mobile devices
    this.setupMobileViewport();
  },
  methods: {
    setupMobileViewport() {
      // Check if viewport meta tag exists
      let viewportMeta = document.querySelector('meta[name="viewport"]');
      
      // If it doesn't exist, create it
      if (!viewportMeta) {
        viewportMeta = document.createElement('meta');
        viewportMeta.name = 'viewport';
        document.head.appendChild(viewportMeta);
      }
      
      // Set the viewport content for proper mobile scaling
      viewportMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
    }
  },
  data() {
    return {
      logo_url: process.env.VUE_APP_LOGO_URL,
      logo_alt: process.env.VUE_APP_NAME,
      project_name: process.env.VUE_APP_NAME,
      project_git: process.env.VUE_APP_PROJECT_GITHUB_LINK,
      author_git: process.env.VUE_APP_AUTHOR_GITHUB_LINK
    }
  }
}
</script>

<style>
.container-content {
  min-height: 100vh;
  max-height: 100vh;
  background-color: #f8f9fa;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
}

body {
  margin: 0;
  padding: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
}

/* Mobile Responsive Styles */
@media (max-width: 767px) {
  .container-content {
    padding: 0;
  }
}
</style>
